import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LazyService } from 'src/app/lazy.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
declare var QRCode: any;

@Component({
    selector: 'kx-qr-login',
    templateUrl: './qr-login.component.html',
    styleUrls: ['./qr-login.component.scss'],
    standalone: false
})
export class QRLoginComponent {
  public config:any={};
  _loadedLibraries: any = {};

  constructor(
    private _lazy: LazyService,
    private baseService: BaseService,
    private alerts: AlertsService,
    private appService: AppService,
    private router: Router,
    private storageService:StorageService
  ) { 
    this.config.qrID = this.appService._currentSessionData.qrLoginPassed;
  }

  ngOnInit(): void {
    if (!this.appService.getSessionId()) {
      this.router.navigateByUrl("/")
    }
    if(this.config.qrID != undefined && this.config.qrID != ""){
      this._lazy.loadScript("./assets/js/qr-code/generate-qr-code.min.js").then((res) => {
        this._loadedLibraries['url'] = "./assets/js/qr-code/generate-qr-code.min.js";
        this.generateCode("KX_AUTH__"+this.config.qrID);
        this.startRequest();
      })
    }else{
      this.alerts.error("INVALID_REQUEST");
    }
    
  }
  generateCode(QRContent) {
    new QRCode(document.getElementById("generated-qr-code"), QRContent);
  }
  

  checkIfAuthenticated() {
    var datasource = {
      query_id: "CHECK_IF_AUTHENTICATED",
      args : "id:"+this.config.qrID,
      filter : "",
      resource: "auth_restriction",
      application: "account-management"
    }
    this.baseService.getByDataSource(datasource).subscribe(
      (res: any) => {
      console.log("data in response in banner detail is :: ", res);
      if (res.errCode == -1) {
        this.alerts.error(res.message)
      } else {
        if(res.resource!= undefined && res.resource.length > 0) {
            if(res.resource[0].id == 'true'){
              window.location.href = window.location.origin;
              this.storageService.reloadOtherTab();
            }else{
              this.startRequest();
            }
        }else{
          this.startRequest();
        }
      }
    }, error => {
      this.startRequest();
    });
  }

  startRequest(){
    clearTimeout(this.config.timeId)
    this.config.timeId = setTimeout(() => {
      this.checkIfAuthenticated();
    }, 10000);
  }

  logout(){
    this.baseService.logout();
  }
  ngOnDestroy(){
    clearTimeout(this.config.timeId)
  }
}
